import 'css-chunksrc/client/scenes/listDuplication/listsList/commentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_k6q2f_1",
  "count": "_count_k6q2f_8",
  "icon": "_icon_k6q2f_14"
};